import {
  Component,
  Input,
  Output,
  EventEmitter,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatButtonToggle } from '@angular/material/button-toggle';
import { IToggleTableInput } from '@firebird-web/shared-ui';

@Component({
  selector: 'firebird-web-toggle-tabs',
  templateUrl: './toggle-tabs.component.html',
  styleUrls: ['./toggle-tabs.component.scss'],
  standalone: false,
})
export class ToggleTabsComponent {
  @Input() labelData!: IToggleTableInput[];
  @Input() selectedLabelKey!: string | null;

  @Output() toggleTab: EventEmitter<IToggleTableInput> =
    new EventEmitter<IToggleTableInput>();

  @ViewChildren(MatButtonToggle)
  private readonly toggles!: QueryList<MatButtonToggle>;

  public readonly lockIconStyles = { top: '4px', right: '6px' };

  identify(index: number) {
    return index;
  }

  selectTab(event: IToggleTableInput): void {
    this.toggleTab.emit(event);
  }

  resync(): void {
    this.toggles.forEach((toggle) => {
      toggle.checked = toggle.value === this.selectedLabelKey;
    });
  }
}
